<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="bidWin">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem v-for="(item, index) in tableList" :key="index" :info="item"></businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { releaseList } from "@/utils/network/interface";
import businessItem from "./item"
export default {
  name: 'bidWin',
  components: {
    businessItem
  },
  props: {
    keyWord: String,
  },
  data () {
    return {
      tableList: [],
      refreshing:false,
      loading:false,
      pageInfo:{
        pageSize:10,
        pageNum:1,
        total:0,
      },
      finished:false
    };
  },
  watch: {
    keyWord (newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = []
      this.onLoad()
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onLoad(){
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const {pageSize ,pageNum} = this.pageInfo
        let obj = { status: 2,pageSize,pageNum,palletsName:this.keyWord}
        releaseList(obj).then(res => {
          if(res.code === 200){
            this.tableList = this.tableList.concat(res.rows)
            this.pageInfo.pageNum ++
            this.pageInfo.total = res.total
            this.loading = false
            if(this.tableList.length >= res.total){
              this.finished = true
            }
          }else{
            this.loading = false
            this.finished = true
          }
        }).catch(err => {
        })
      }, 1000);
    },
    getData () {
      let obj = { status: 2,pageSize:10,pageNum:1,palletsName:this.keyWord}
      releaseList(obj).then(res => {
        this.refreshing =false  
        this.loading = false
        if(res.code == 200){
          this.tableList = res.rows
          this.pageInfo.pageNum ++
          this.pageInfo.total = res.total
        }
      }).catch(err => {
      })
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum =1
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.bidWin {
}
</style>